/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { SpaceScale } from '@bevolta/design-tokens';
import templateOnlyComponent from '@ember/component/template-only';

interface BvTextContainerSignature {
  Args: {
    spacing?: SpaceScale;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvTextContainerComponent = templateOnlyComponent<BvTextContainerSignature>();

export default BvTextContainerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvTextContainer: typeof BvTextContainerComponent;
    'bv-text-container': typeof BvTextContainerComponent;
  }
}
